



















import Vue from 'vue';
import { mapState } from 'vuex';

import Discount from '@/types/Discount';

import Field from '@/components/Bulma/Field.vue';
import TInput from '@/components/Bulma/TInput.vue';
import HorizontalField from '@/components/Bulma/HorizontalField.vue';

export default Vue.extend({
    name: 'Coupon',

    components: {
        Field,
        TInput,
        HorizontalField
    },

    props: {
        value: Object as () => Discount,
        readonly: Boolean
    },

    methods: {
        input(): void {
            this.$emit('input', this.value);
        }
    }
});
